import {
  DraftSpecialTextConfiguration,
  DraftState,
  DraftTextConfiguration,
  SpecialFontTask,
  StoreSpecialFont,
} from '@/types';
import { convertSizePxToSizeMm } from '@/model/configuration/convertSize';
import { getAvailablePrintTypes } from '@/model/configuration/getAvailablePrintTypes';
import { getCurrentSizeOfConfiguration } from '@/model/configuration/getCurrentSizeOfConfiguration';
import { getAppearance } from '@/model/draft/getAppearance';
import { equalizeOnAdd } from './helper/equalizeOnAdd';
import { updateSizeAndOffset } from './helper/updateSizeAndOffset';

export const convertTextToSpecialTextAction =
  (configuration: DraftTextConfiguration, font: StoreSpecialFont, task: SpecialFontTask) =>
  (draft: DraftState) => {
    const draftSpecialTextConfiguration: DraftSpecialTextConfiguration = {
      ...configuration,
      type: 'specialText',
      text: {
        content: configuration.text.content,
        style: {
          ...configuration.text.style,
          font,
        },
      },
      printType: getAvailablePrintTypes(configuration, getAppearance(draft))[0],
      task,
    };

    const taskSize = convertSizePxToSizeMm(task.size, configuration.printType);
    updateSizeAndOffset(
      draftSpecialTextConfiguration,
      taskSize,
      getCurrentSizeOfConfiguration(configuration).width / taskSize.width
    );

    draft.configurations[draftSpecialTextConfiguration.cid] = draftSpecialTextConfiguration;

    equalizeOnAdd(draft, draftSpecialTextConfiguration);
  };
